





































































































import Vue from 'vue'

interface Data {}
interface Methods {}
interface Computed {}
interface Props {
  disabled: boolean,
  hasDisabledStyle: boolean,
  text: string,
  isSecondary: boolean,
  isWarning: boolean,
  isError: boolean,
  type: string
  size: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'Button',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hasDisabledStyle: Boolean,
    text: String,
    isSecondary: Boolean,
    isWarning: Boolean,
    isError: Boolean,
    type: {
      type: String,
      default: 'submit',
      required: false
    },
    size: {
      type: String,
      default: 'large',
      validator: (value) => ['large', 'small'].indexOf(value) !== -1
    }
  }
})
